import { useDispatch } from "react-redux";
import { useSelector } from "store/useSelector";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { usePrevious } from "constants/constants";
import {
  updateCustomerKey,
  updateSummaryGroup,
  updateDetailKey,
} from "../../store/customerSlice";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";

/** url  params are flight.raven.ai/:ckey/dashboard/:summaryGroup/:detailKey
 *
 * when the location changes, update the ckey, summaryGroup, detailKey if necessary
 */
const SyncUrlParamsToStore = () => {
  // sync the ckey
  useSyncUrlParamToStore("ckey", updateCustomerKey, true);
  // sync the summaryGroup
  useSyncUrlParamToStore("summaryGroup", updateSummaryGroup);
  // sync the detailKey
  useSyncUrlParamToStore("detailKey", updateDetailKey);

  return null;
};

export default SyncUrlParamsToStore;

// use this to find the matching param in the window.location.pathname
const URL_WITH_STORED_PARAM_NAMES =
  "/ckey/dashboard/summaryGroup/detailKey".split("/");

function useSyncUrlParamToStore(
  storeKey: string,
  dispatchFn: ActionCreatorWithPayload<string, string>,
  shouldLowerCase = false
) {
  const paramIndex = URL_WITH_STORED_PARAM_NAMES.indexOf(storeKey);

  const dispatch = useDispatch();
  const location = useLocation();

  const valueInStore = useSelector(state => state.customer[storeKey]);
  const newValue = location.pathname.split("/")[paramIndex] || ""; // no value is an expected case for ckey, summaryGroup, and detailKey, so default to ""
  const prevValue = usePrevious(valueInStore);
  useEffect(() => {
    if (
      prevValue !== newValue &&
      newValue !== "iframe.html" /* happens in storybook */ &&
      newValue !== "callback" /* happens when you redirect from login page */
    ) {
      const newValueCased = shouldLowerCase ? newValue.toLowerCase() : newValue;
      const newValueDecoded = decodeURIComponent(newValueCased);
      if (newValueDecoded !== "auth-failed") {
        dispatch(dispatchFn(newValueDecoded));
      }
    }
  }, [shouldLowerCase, newValue, dispatch, prevValue, dispatchFn]);
}
